import { z } from 'zod';

import { IsoDateTimeSchema } from '../common/datetime';

import { DevicePlatform } from './devices';
import { StaffMeSiteSchema } from './me';
import { PrivacyNoticeVersionSchema } from './privacy';

// ---------------------------------------------------------------------------
// `GET /profile` del realm staff — perfil del trabajador
// (feature 006, `contracts/staff-api.md` §2, `data-model.md` §2.4).
//
// Sin número ni tipo de documento, código interno, teléfono, correo, ids de dispositivo o sesión,
// `user_agent` crudo ni IP.
// ---------------------------------------------------------------------------

/** Dispositivo de la sesión: columnas de QA-5 o, si están vacías, derivadas del `user_agent`. */
export const StaffProfileDeviceSchema = z.object({
  platform: DevicePlatform,
  os_name: z.string().nullable(),
  os_version: z.string().nullable(),
  browser_name: z.string().nullable(),
  browser_version: z.string().nullable(),
  /** Solo Android con Client Hints (QA-5). */
  model: z.string().nullable(),
  enrolled_at: IsoDateTimeSchema,
});
export type StaffProfileDevice = z.infer<typeof StaffProfileDeviceSchema>;

export const StaffProfileSchema = z.object({
  worker: z.object({ first_names: z.string(), last_names: z.string() }),
  company: z.object({ trade_name: z.string() }),
  /** Principal primero, luego por nombre. */
  sites: z.array(StaffMeSiteSchema),
  device: StaffProfileDeviceSchema,
  privacy_notice: z.object({
    version: PrivacyNoticeVersionSchema,
    accepted_at: IsoDateTimeSchema.nullable(),
  }),
});
export type StaffProfile = z.infer<typeof StaffProfileSchema>;
